module.exports = __webpack_public_path__ + "static/media/11.ca21a4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/11.png
// module id = 1341
// module chunks = 0